import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { PlantlifeBusinessCardStackContentViewModel } from './plantlife-business-card-stack-content-view-model';
import { PlantlifeBusinessCardStackSharedLogicContentComponent } from '../plantlife-business-card-stack-shared-logic-content.component';

@Component({
  selector: 'app-plantlife-business-card-stack-content',
  templateUrl: './plantlife-business-card-stack-content.component.html',
  styleUrls: ['./plantlife-business-card-stack-content.component.scss'],
  providers: [PlantlifeBusinessCardStackContentViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PlantlifeBusinessCardStackContentComponent
  extends PlantlifeBusinessCardStackSharedLogicContentComponent
  implements AfterViewInit, OnDestroy
{
  constructor(
    override viewModel: PlantlifeBusinessCardStackContentViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }
}
